import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';

import { ConnectedPage } from './../root_classes/connected-page';
import { ConstantsModule } from '../constants/constants.module';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent extends ConnectedPage implements OnInit {

	constructor(constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal) {
		super(constantsModule, cookieService, httpClient, router, modalService);
	}

	ngOnInit(): void {
		// Sending disconnection to the server.
		this.put("/api/logout", undefined,
			(data: any) => {
				// Cleaning the role proxy.
				this.closeConnexion();

				// Routing to login page.
				this.router.navigateByUrl("/login");
			},
			(err) => {}
		);
	}
}
